// extracted by mini-css-extract-plugin
module.exports = {"home":"MetropoleHome_home__h8YLG"};